module.exports = "/images/tag_81112f.png";